import type { AnonymousUser, User } from '@iheartjane/data-access';
import type { Nullable } from '@iheartjane/types';

export type Whoami = {
  user: User | AnonymousUser;
  user_segments: number[];
};

export type UserResponse = {
  jwtToken: string;
  refreshToken?: string;
};

export interface UserIdentity extends UserResponse, Whoami {}

export function isJaneUser(user?: User | AnonymousUser): user is User {
  return !!user?.authenticated;
}

export interface GoogleOAuthUser extends User {
  new_oauth: Nullable<boolean>;
  new_registration: Nullable<boolean>;
}
